const months=['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
const present=v=>v!==null&&v!==undefined&&String(v).trim()!=='';
export function plantCharacteristics(params=[],specs={},labels={}){
 return params.flatMap(p=>{
  const spec=specs[p.name]||{},raw=Array.isArray(p.values)?p.values:[p.values];
  if(!raw.some(present))return [];
  const translated=v=>['fruiting_time','blooming_time'].includes(p.name)?months[Number(v)]||String(v):labels[v]??String(v);
  let value;
  if(spec.unit){
   if(p.name==='planting_scheme')value=raw.filter(present).map(String).join(' × ');
   else if(raw.length===2&&(!present(raw[0])||(['fruit_weight','height','ripening_period','plant_yield','flower_diameter'].includes(p.name)&&Number(raw[0])===0&&Number(raw[1])>0)))value='до '+raw[1];
   else if(raw.length===2&&!present(raw[1]))value='от '+raw[0];
   else value=raw.filter(present).map(String).join('–');
   value+=' '+spec.unit;
  }else value=raw.filter(present).map(translated).join(p.name==='facts'?'; ':', ');
  return [{name:p.name,label:spec.label||p.name,values:raw.filter(present).map(translated),value}];
 });
}
